import { createFileRoute, redirect } from "@tanstack/react-router";

// The old page lives on as a permanent redirect so existing links and search results keep working.
export const Route = createFileRoute("/intelligence")({
  beforeLoad: () => {
    throw redirect({ to: "/chef-brain", statusCode: 301 });
  },
});
